// @flow
import { Grid } from 'semantic-ui-react';
import React from 'react';
import { useFormikContext } from 'formik';
import { COMMITTED_CAPACITY } from '@streaming-projects/user-commit-details/committed-capacity/enums';
import { ECKUDimensionColumns } from '@streaming-projects/user-commit-details/committed-capacity/dimensions/ECKUDimensionColumns';
import { If } from '@presentational/If';
import { CFUDimensionColumns } from '@streaming-projects/user-commit-details/committed-capacity/dimensions/CFUDimensionColumns';
import { QuantityContainer } from '@streaming-projects/user-commit-details/committed-capacity/dimensions/QuantityContainer';
import { CommittedCapacityDimensionsLineItemSaveContainer } from '@streaming-projects/user-commit-details/committed-capacity/dimensions/CommittedCapacityDimensionsLineItemSaveContainer';
import { Spacer } from '@presentational/spacing/Spacer';
import { CommittedCapacityDimensionsLineItemDeleteContainer } from '@streaming-projects/user-commit-details/committed-capacity/dimensions/CommittedCapacityDimensionsLineItemDeleteContainer';
import { getIfGivenRowIsBeingEditedORANewOne } from '@streaming-projects/user-commit-details/committed-capacity/utils';

const getStylesBasedOnTheGivenRowValues = (row) => {
  const style = getIfGivenRowIsBeingEditedORANewOne(row)
    ? {
        backgroundColor: '#2185D014',
        borderRadius: '12px',
      }
    : {};

  return {
    ...style,
    paddingTop: '1rem',
    paddingBottom: '1rem',
  };
};

export const SPCommittedCapacityDimensionsSingleRow = ({
  metricIndex,
  dimensionIndex,
  row,
  metricRow,
  dimensionArrayHelpers,
  metricArrayHelpers,
}) => {
  const { values } = useFormikContext();
  const configuredMetrics = values?.[COMMITTED_CAPACITY.METRICS_LEVEL_CONFIGURATION_ARRAY] ?? [];
  const styles = getStylesBasedOnTheGivenRowValues(row);

  const metricName = metricRow.metricName;
  return (
    <>
      <Grid.Row style={styles}>
        <If test={metricName === 'ecku'}>
          <ECKUDimensionColumns
            dimensionIndex={dimensionIndex}
            metricIndex={metricIndex}
            row={row}
          />
        </If>
        <If test={metricName === 'cfu'}>
          <CFUDimensionColumns
            dimensionIndex={dimensionIndex}
            metricIndex={metricIndex}
            row={row}
          />
        </If>
        <Grid.Column width={2}>
          <QuantityContainer
            configuredMetrics={configuredMetrics}
            dimensionIndex={dimensionIndex}
            dimensionRow={row}
            metricIndex={metricIndex}
            metricRow={metricRow}
          />
        </Grid.Column>
        <Grid.Column width={3}>
          <CommittedCapacityDimensionsLineItemSaveContainer
            configuredMetrics={configuredMetrics}
            dimensionArrayHelpers={dimensionArrayHelpers}
            dimensionIndex={dimensionIndex}
            dimensionRow={row}
            metricRow={metricRow}
            reloadPageAfterUpdate={true}
          />
          <Spacer x={15} />
          <CommittedCapacityDimensionsLineItemDeleteContainer
            configuredMetrics={configuredMetrics}
            dimensionArrayHelpers={dimensionArrayHelpers}
            dimensionIndex={dimensionIndex}
            dimensionRow={row}
            metricArrayHelpers={metricArrayHelpers}
            metricIndex={metricIndex}
            metricRow={metricRow}
            reloadPageAfterDelete={true}
          />
        </Grid.Column>
      </Grid.Row>
    </>
  );
};
